// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__2JovL","content":"Footer_content__13qY5","logo":"Footer_logo__1jN69","contacts":"Footer_contacts__3HrUJ","footerNotes":"Footer_footerNotes__1bkHv"};